import { Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-required-permissions',
  templateUrl: './no-required-permissions.component.html',
})
export class NoRequiredPermissionsComponent {
  @HostBinding('class')
  private readonly classes = 'flex w-full h-full items-center justify-center';

  constructor(private router: Router) {}

  backToAnecdotes(): void {
    this.router.navigate(['/']);
  }
}
